/* global L */

//package last update: 8/22

export var MarkerTool = new AshIconMarkerTool();

function AshIconMarkerTool() {
    var TOOL = this;
    var defaultColor = '#FFF';
    var defaultBgColor = '#FF6464';
    var defaultTextColor = 'yellow';
    var iconSize = {
        'small': [20, 32],
        'medium': [26, 40]
    };
    var iconMarkerClass = {
        'small': 'ash-icon-small',
        'medium': 'ash-icon-medium'
    };
    var iconCircleSize = {
        'tiny': [10, 10],
        'small': [15, 14],
        'medium': [24, 24],
        'large': [36, 36]
    };
    var iconCircleMarkerClass = {
        'tiny': 'ash-circle-icon-tiny',
        'small': 'ash-circle-icon-small',
        'medium': 'ash-circle-icon-medium',
        'large': 'ash-circle-icon-large'
    };

    TOOL.create = function (options) {
        var myIcon;
        var ID = options.ID || '';

        if (options.type === 'icon_marker') {
            var icon_style = '';
            icon_style += 'color:' + (options.color || defaultColor) + ';';
            if (options.marker_opacity) {
                icon_style += 'opacity:' + options.marker_opacity + ';';
            }
            var circle_color = 'background-color:' + (options.background_color || defaultBgColor) + ';';
            var triangle_color = 'border-top-color:' + (options.background_color || defaultBgColor) + ';';

            var icon_html = '';
            icon_html += '<div id="' + ID + '" class="icon_container" style="' + icon_style + '">';
            //            icon_html += '<div class="marker_border"></div>';
            icon_html += '  <div class="marker_bgcolor">';
            icon_html += '      <div class="bg_circle" style="' + circle_color + '"></div>';
            icon_html += '      <div class="bg_triangle" style="' + triangle_color + '"></div>';
            icon_html += '  </div>';
            icon_html += get_icon_html(options.icon_type, options.icon_name);
            icon_html += (options.marker_text) ? get_marker_text_html(options.marker_text, options.text_color) : '';
            icon_html += '</div>';

            var size = iconSize[options.marker_size || 'medium'];
            myIcon = L.divIcon({
                className: 'ash-icon ' + iconMarkerClass[options.marker_size || 'medium'] + ' ' + (options.class_name || ''),
                iconSize: size,
                iconAnchor: [size[0] / 2, size[1] - 4],
                html: icon_html
            });
        } else if (options.type === 'icon_circle_marker') {
            var icon_style = '';
            if (options.color) {
                icon_style += 'color:' + options.color + ';';
            }
            if (options.background_color) {
                icon_style += 'background-color:' + options.background_color + ';';
            }
            if (options.marker_opacity) {
                icon_style += 'opacity:' + options.marker_opacity + ';';
            }

            var border_class;
            if (options.border === false) {
                border_class = '';
            } else if (options.border === 'black') {
                border_class = 'with-black-border';
            } else {
                border_class = 'with-white-border';
            }
            var shadow_class = (options.shadow === false) ? '' : 'with-shadow ';

            var icon_html = '';
            icon_html += '<div id="' + ID + '" class="icon_container ' + border_class + '" style="' + icon_style + '">';
            icon_html += get_icon_html(options.icon_type, options.icon_name);
            icon_html += '</div>';

            myIcon = L.divIcon({
                className: 'ash-circle-icon ' + shadow_class + iconCircleMarkerClass[options.marker_size || 'small'] + ' ' + (options.class_name || ''),
                iconSize: iconCircleSize[options.marker_size || 'small'],
                html: icon_html
            });
        }
        return myIcon;
    };

    function get_icon_html(type, icon) {
        if (type === 'material') {
            return '<i class="material-icons">' + (icon || 'grade') + '</i>';
        } else if (type === 'fa') {
            return '<i class="fa ' + (icon || 'fa-star') + '" aria-hidden="true"></i>';
        } else if (type === 'icon') {
            return '<i class="icon ' + icon + '" aria-hidden="true"></i>';
        } else {
            return '<span class="glyphicon ' + (icon || 'glyphicon-star') + '"></span>';
        }
    }

    function get_marker_text_html(marker_text, text_color) {
        var color = 'color:' + (text_color ? text_color : defaultTextColor) + ';';
        var style = color;
        return  '<div class="marker_text" style="' + style + '">' + marker_text + '<div>';
    }

}